import * as React from 'react';
import useStyles from './ExocadFooter.styles';
import { Trans } from '@lingui/react';
import { CustomCiamUiTheme } from '../../../theme';
import { useTheme } from 'react-jss';

export interface IExocadFooterProps {
  privacyLink: string;
  termsOfUseLink: string;
}

const ExocadFooter: React.FC<IExocadFooterProps> = ({
  privacyLink,
  termsOfUseLink,
}) => {
  const theme = useTheme<CustomCiamUiTheme>();
  const classes = useStyles({ theme });
  return (
    <div className={classes.root}>
      <Trans
        id="By continuing with login or registration, you agree to our <0>my.exocad Terms and Conditions</0>. For more information about how my.exocad handles your data, please read our <1>Privacy Policy</1>."
        components={{
          0: <a className={classes.link} href={termsOfUseLink} />,
          1: <a className={classes.link} href={privacyLink} />,
        }}
      />
    </div>
  );
};

export default ExocadFooter;
